import { FC } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import clsx from 'clsx'

import Button from 'components/parts/button/button'

import { Pathname } from 'constants/data'
import { imgData, logoData } from './data'

import styles from './banner-crowdfunding.module.scss'

const BannerCrowdfunding: FC = () => {
  return (
    <div className={clsx(styles.crowdBannerWrapper)}>
      <div className={clsx(styles.txtWrap)}>
        <div className={styles.title}>Поддерживаем врачей в&nbsp;учебе и жизни</div>
        <div className={styles.subtitle}>
          Мы ежемесячно переводим фонду сумму, равную количеству часов, проведенных каждым из вас за
          просмотром вебинаров.
        </div>
        <div className={styles.btnWrap}>
          <Link href={`/${Pathname.CROWD_FUNDING}`}>
            <Button>Подробнее</Button>
          </Link>
          <Image className={styles.logo} {...logoData} />
        </div>
      </div>
      <div className={clsx(styles.imgWrap)}>
        <Image {...imgData} />
      </div>
    </div>
  )
}
export default BannerCrowdfunding
